export enum LoanRate {
        FIXED_30_YEAR_MORTGAGE = 17,
        FIXED_15_YEAR_MORTGAGE = 18,
        FIRST_TIME_HOMEBUYER = 19,
        HOME_EQUITY_LINE_OF_CREDIT = 20,
        MINI_MORTGAGE_7_YR_FIXED_1ST = 21,
        MINI_MORTGAGE_10_YR_FIXED_1ST = 22,
        MINI_MORTGAGE_12_YR_FIXED_1ST = 23,
        CONSTRUCTION_LOAN = 42,
        HOME_EQUITY_LOAN_5_YR_FIXED = 44,
        MINI_MORTGAGE_5_YR_FIXED_1ST = 59,
        HOME_EQUITY_LOAN_7_YR_FIXED = 70,
        HOME_EQUITY_LOAN_10_YR_FIXED = 71,
        HOME_EQUITY_LOAN_12_YR_FIXED = 72,
        FIXED_20_YEAR_MORTGAGE = 78,
        FIXED_30_YEAR_MORTGAGE_REFINANCE = 82,
        FIXED_20_YEAR_MORTGAGE_REFINANCE = 83,
        FIXED_15_YEAR_MORTGAGE_REFINANCE = 84,
        MINI_MORTGAGE_15_YR_FIXED_1ST = 86,
        JUMBO_15_YEAR = 87,
        JUMBO_20_YEAR = 88,
        JUMBO_30_YEAR = 89,
        USDA_30_YEAR = 90,
        FHA_15_YEAR = 91,
        FHA_30_YEAR = 92,
        VA_15_YEAR = 93,
        VA_30_YEAR = 94,
        LOT_10_YEAR_LOAN = 95,
        LOT_20_YEAR_LOAN_WITH_7_YEAR_BALLOON = 97,
        ADJUSTABLE_RATE_MORTGAGE_5_6 = 101,
        FIRST_TIME_HOMEBUYER_7_6_ADJUSTABLE_RATE_MORTGAGE = 102,
        ADJUSTABLE_RATE_MORTGAGE_7_6 = 103,
        ADJUSTABLE_RATE_MORTGAGE_10_6 = 104,
        FIXED_40_YEAR_RATE_WITH_15_YEAR_BALLOON = 105,
        FIXED_15_YEAR_RATE_SECOND_MORTGAGE = 109,
        FIXED_20_YEAR_SECOND_MORTGAGE = 110,
        FIXED_30_YEAR_SECOND_MORTGAGE_WITH_15_YEAR_BALLOON = 111,
        FIXED_15_YEAR_HOME_EQUITY = 112,
}